// `import.meta.env` is Vite's; under plain Node (the tests) it is undefined, so
// read it optionally and fall back to the local defaults below.
const env = import.meta.env as Record<string, string | undefined> | undefined;

const rootDomain = env?.VITE_HAZUMU_ROOT_DOMAIN;

const mediaUrl = env?.VITE_HAZUMU_MEDIA_URL;

const hazumuRootDomain = (rootDomain?.trim() || "hazumu.localhost").toLowerCase();

export const config = {
  hazumuRootDomain,
  // Where uploaded images are served from (worker/media.ts): media.<root>,
  // or /media on a local root, which Vite proxies to `wrangler dev`.
  mediaBaseUrl: (
    mediaUrl?.trim() ||
    (hazumuRootDomain.endsWith("localhost") ? "/media" : `https://media.${hazumuRootDomain}`)
  ).replace(/\/+$/, ""),
};
